const CARDS = [
  {
    title: '热门电视剧',
    desc: '卫视同步热播剧、网络独播大剧一网打尽，每日更新不等待',
    tag: '日更200+集',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20cozy%20living%20room%20scene%20with%20a%20large%20TV%20screen%20showing%20Chinese%20drama%20series%2C%20soft%20ambient%20lighting%2C%20modern%20minimal%20interior%2C%20warm%20wood%20tones%2C%20comfortable%20atmosphere%2C%20cinematic%20color%20grading&width=800&height=500&seq=card-tv-2026-x1&orientation=landscape',
  },
  {
    title: '最新电影',
    desc: '院线新片、高清大片抢先看，覆盖国内外主流片源库',
    tag: '30000+部',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20theater%20interior%20with%20red%20velvet%20seats%20and%20a%20large%20silver%20screen%20glowing%2C%20warm%20golden%20lighting%2C%20elegant%20atmosphere%2C%20premium%20viewing%20experience%2C%20rich%20dark%20and%20gold%20color%20palette&width=800&height=500&seq=card-movie-2026-x1&orientation=landscape',
  },
  {
    title: '综艺娱乐',
    desc: '热门综艺、搞笑节目、真人秀等丰富内容，轻松解压随时看',
    tag: '500+档',
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20colorful%20TV%20studio%20set%20with%20vibrant%20stage%20lighting%2C%20variety%20show%20atmosphere%2C%20energetic%20and%20fun%20vibe%2C%20modern%20broadcast%20studio%20design%2C%20warm%20spotlights%2C%20entertainment%20production%20scene&width=800&height=500&seq=card-variety-2026-x1&orientation=landscape',
  },
  {
    title: '动漫番剧',
    desc: '日漫、国漫、经典番剧大全，二次元爱好者的追番必备工具',
    tag: '10000+部',
    image: 'https://readdy.ai/api/search-image?query=A%20creative%20animation%20studio%20workspace%20with%20colorful%20character%20designs%20on%20walls%2C%20drawing%20tablets%2C%20warm%20artistic%20lighting%2C%20vibrant%20anime%20art%20style%20posters%2C%20modern%20creative%20environment%2C%20soft%20natural%20light&width=800&height=500&seq=card-anime-2026-x1&orientation=landscape',
  },
  {
    title: '纪录片专区',
    desc: 'BBC、国家地理等顶级纪录片，探索自然人文与未知世界',
    tag: '高清画质',
    image: 'https://readdy.ai/api/search-image?query=A%20serene%20nature%20documentary%20scene%20with%20majestic%20mountain%20landscapes%2C%20golden%20hour%20sunlight%2C%20wildlife%20in%20natural%20habitat%2C%20cinematic%20aerial%20photography%20style%2C%20warm%20earthy%20tones%2C%20breathtaking%20vista&width=800&height=500&seq=card-doc-2026-x1&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            内容品类
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            海量影视资源，一站在手全部拥有
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            91影视看片app覆盖五大核心品类，满足不同口味的观影需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {CARDS.map((card, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={card.image}
                  alt={`91影视看片 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 bg-black/50 backdrop-blur-sm text-white text-xs font-medium rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}